import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  coupons: {},
  orders: {},
  products: {},
  uiFlags: {
    isFetchingCoupons: false,
    isFetchingOrders: false,
    isSearchingProducts: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
